import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    const el = this.hasContainerTarget ? this.containerTarget : this.element
    requestAnimationFrame(() => {
      el.scrollTop = el.scrollHeight
    })
  }
}
